var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-contact-agency-page"},[_c('div',{staticClass:"alert alert-warning mt-5",attrs:{"role":"alert"}},[_vm._v(" Your account is not currently subscribed. Please reach out to your agency administrator for assistance. ")])])
}]

export { render, staticRenderFns }